import { type SignUpProps } from './SignUp'

export const defaultProps: SignUpProps = {
  buttonTestId: 'continue_btn',
  attributes: {},
  emailFields: {
    buttonText: 'CONTINUE',
    freeUserRedirectURL: '/',
  },
  privacyPolicyLink: 'https://teambeachbody.com/shop/us/wcs/privacy?locale=en_US',
  termsAndConditionsLink: 'https://teambeachbody.com/shop/us/wcs/termsOfUse?locale=en_us',
  passwordFields: {
    buttonText: 'CREATE ACCOUNT',
    redirectURL: '/',
    ruleMinEightMaxTwentyChars: '8-20 Characters',
    ruleOneUpper: 'One Uppercase Letter',
    ruleOneLower: 'One Lowercase Letter',
    ruleOneNumber: 'One Number',
    ruleNoBannedChars: 'No ’_\\/“<>, characters or spaces',
  },
}
